import React from "react";
import { Loader } from "react-loaders";

const MyLoader = () => {
  return <Loader type="line-scale" active />;
};

export default MyLoader;
